import type { CreditsInfo } from "../credits";

interface CreditsBadgeProps {
  creditsInfo: CreditsInfo;
}

export function CreditsBadge({ creditsInfo }: CreditsBadgeProps) {
  const { remaining, freeLeft, paidLeft } = creditsInfo;

  let label: string;
  if (freeLeft > 0) {
    label = `${freeLeft} free check${freeLeft === 1 ? "" : "s"} left`;
  } else {
    label = `${paidLeft} credit${paidLeft === 1 ? "" : "s"}`;
  }

  const isLow = remaining <= 1;

  return (
    <span
      className="inline-flex items-center px-2.5 py-1 rounded-full mono-label"
      style={{
        fontSize: "0.6rem",
        border: `1px solid ${isLow ? "rgba(255,68,68,0.25)" : "rgba(34,197,94,0.2)"}`,
        color: isLow ? "rgba(255,68,68,0.6)" : "rgba(34,197,94,0.6)",
        background: isLow ? "rgba(255,68,68,0.05)" : "rgba(34,197,94,0.05)",
      }}
    >
      {label}
    </span>
  );
}
